var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"hero is-primary",style:({
      background:
        'linear-gradient(153deg, rgba(254,14,14,1) 18%, rgba(254,199,14,1) 100%)',
    })},[_c('div',{staticClass:"hero-body"},[_c('h1',{staticClass:"title"},[_vm._v("This is the error page :D")]),_c('h1',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.message))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }